import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";

import Dashboard from "@/pages/Dashboard";
import AnchorPage from "@/pages/AnchorPage";
import Verify from "@/pages/Verify";
import Ada4wm from "@/pages/Ada4wm";
import Hct3 from "@/pages/Hct3";
import KCrypto from "@/pages/KCrypto";
import StateCapture from "@/pages/StateCapture";
import DriftMonitor from "@/pages/DriftMonitor";
import Reconstruction from "@/pages/Reconstruction";
import Vault from "@/pages/Vault";
import Architecture from "@/pages/Architecture";
import About from "@/pages/About";
import Workflow from "@/pages/Workflow";
import EvidencePack from "@/pages/EvidencePack";

function App() {
  return (
    <div className="App dark">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/workflow" element={<Workflow />} />
              <Route path="/anchor" element={<AnchorPage />} />
              <Route path="/verify" element={<Verify />} />
              <Route path="/ada4wm" element={<Ada4wm />} />
              <Route path="/hct3" element={<Hct3 />} />
              <Route path="/kcrypto" element={<KCrypto />} />
              <Route path="/state-capture" element={<StateCapture />} />
              <Route path="/drift" element={<DriftMonitor />} />
              <Route path="/reconstruction" element={<Reconstruction />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/evidence-pack" element={<EvidencePack />} />
              <Route path="/architecture" element={<Architecture />} />
              <Route path="/about" element={<About />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors closeButton />
      </AppProvider>
    </div>
  );
}

export default App;
